// extracted by mini-css-extract-plugin
module.exports = {"wrap":"UserName_wrap__217UQ","userId":"UserName_userId__b3gAK","name":"UserName_name__3gQ8T"};